var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dlgVisible,
        center: "",
        title: "重复投保",
        top: "25vh",
        width: "80%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dlgVisible = $event
        },
      },
    },
    [
      _c("avue-crud", {
        attrs: { data: _vm.dataCarRepeat, option: _vm.optionCarRepeat },
      }),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  _vm.dlgVisible = false
                },
              },
            },
            [_vm._v("我已知晓")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }